import { token } from '../routes/user/user.state.svelte.js';
import { get as getStore } from 'svelte/store';
import { notificate } from './notification.js';
import { format, locale } from 'svelte-i18n';


const API_URL = VULSEEK_API_URL; // global variable defined in /js/env.js
const APP_URL = VULSEEK_APP_URL; // global variable defined in /js/env.js

let access_token = $derived(token.access_token);

function setLocale() {
    let setLocale = getStore(locale);
    if (setLocale != "es" && setLocale != "en") setLocale = 'es';
    locale.set(setLocale);
}

export function get(resource, config = {}) {
    const defaults = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };

    config = { ...defaults, ...config };

    const url = new URL(`${API_URL}/${resource}`);

    if (config.filter) {
        url.search = new URLSearchParams(config.filter).toString();
    }

    return fetch(url, config)
        .catch(e => {
            if (e.name === 'AbortError') {
                // intentional cancellation
                throw e;
            }
            notificate('network_error');
            throw e;
        })
        .then(async response => {
            setLocale();

            if (!response.ok) {
                if (response.status === 403 && !token.access_token) {
                    location.href = APP_URL + "/login?session_expired";
                }

                if (response.status === 401) {
                    token.access_token = null;
                    window.location.replace(APP_URL + "/login?session_expired");
                }

                if (resource.includes("/note") && response.status === 404) {
                    return { content: getStore(format)("errors.vul_no_note") };
                }

                notificate(`${response.status}`);
                throw new Error(response.status);
            }

            const contentType = response.headers.get('Content-Type') ?? '';
            return contentType.includes('text/plain')
                ? response.text()
                : response.json();
        });
}

export function search(resource, config) {
    return get(resource, config);
}

export function find(resource, id, config) {
    return get(`${resource}/${id}`, config);
}

export function save(resource, data = {}, files = [], config = {}, is_upsert = false) {
    const url = `${API_URL}/${resource}` + (data.id ? `/${data.id}` : '/');
    const method = (data.id && !is_upsert) ? 'PATCH' : 'POST';

    if (!files.length) {
        let defaults = {
            method: method,
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
        };

        config = { ...defaults, ...config };
        return fetch(url, config)
            .catch(e => {
                notificate('network_error');
                throw new Error(e);
            })
            .then(response => {
                return response;
            })
            ;
    }
    // file uploads
    let formData = new FormData();

    formData.append('data', JSON.stringify(data));

    files.map((value, key) => {
        formData.append('file_obj', value);
    });

    let defaults = {
        method: method,
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
        body: formData,
    };

    config = { ...defaults, ...config };

    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export function saveMultipart(resource, data = {}, files = [], config = {}, fileKey = 'file_obj') {
    const url = `${API_URL}/${resource}` + (data.id ? `/${data.id}` : '/');
    const method = data.id ? 'PATCH' : 'POST';

    let formData = new FormData();

    // Datos planos
    Object.keys(data).forEach(key => {
        if (data[key] !== undefined && data[key] !== null) {
            formData.append(key, data[key]);
        }
    });

    // Archivos con la KEY dinámica (aquí estaba el error)
    files.forEach((file) => {
        formData.append(fileKey, file);
    });

    let defaults = {
        method: method,
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
        body: formData,
    };

    config = { ...defaults, ...config };
    return fetch(url, config);
}

// FUNCION AGREGADA PARA LA EDICIÓN (SIN MODIFICAR LAS ANTERIORES)
export function updateMultipart(resource, id, data = {}, files = [], config = {}, fileKey = 'file_obj') {
    const url = `${API_URL}/${resource}/${id}`;
    const method = 'PATCH';

    let formData = new FormData();

    Object.keys(data).forEach(key => {
        if (data[key] !== undefined && data[key] !== null) {
            formData.append(key, data[key]);
        }
    });

    files.forEach((file) => {
        formData.append(fileKey, file);
    });

    let defaults = {
        method: method,
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
        body: formData,
    };

    config = { ...defaults, ...config };
    return fetch(url, config);
}

export function upsert(resource, data = {}, files = [], config = {}) {
    return save(resource, data, files, config, true)
}

export function taskExecute(resource, config = {}) {
    let defaults = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };
    let url = new URL(`${API_URL}/${resource}`);
    if (config.hasOwnProperty('params')) {
        url.search = new URLSearchParams(config.params).toString();
    }
    config = { ...defaults, ...config };
    return fetch(url, config)
        .then(async response => {
            if (response.status === 207) {
                return await response.json();
            }
            return await response.json();
        })
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export function del(resource, ids, config) {
    let defaults = {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        },
    };

    let url = `${API_URL}/${resource}`

    if (Array.isArray(ids)) {
        defaults = { ...defaults, body: JSON.stringify(ids) }
    }

    if (typeof ids === 'string') {
        url = url + `/${ids}`;
    }
    config = { ...defaults, ...config };
    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export function deleteTags(resource, data, config) {
    let defaults = {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    };

    let url = `${API_URL}/${resource}`

    config = { ...defaults, ...config };

    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export function deleteOneResource(resource, id, config) {
    let defaults = {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        },
    };

    config = { ...defaults, ...config };
    return fetch(`${API_URL}/${resource}/${id}`, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export async function getFile(resource, config = {}) {
    setLocale();
    let file;
    let defaults = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${access_token}`,
            "Accept": "text/html",
            "Accept-Language": "en-US,en;q=0.5",
        }
    };

    config = { ...defaults, ...config };

    return file = await fetch(`${API_URL}/${resource}`, config)
        .catch(e => {
            throw new Error(getStore(format)("notifications.network_error"));
        })
        .then(response => {
            if (!response.ok) {
                if (response.status === 404) {
                    throw new Error(getStore(format)("errors.no_tag_combination"));
                }
                else if (response.status === 502) {
                    throw new Error(getStore(format)("notifications.network_error"))
                }
                else {
                    throw new Error(getStore(format)("notifications.network_error"));
                }
            }
            return response;
        })
        ;
}


export async function saveFile(resource, data = {}, config = {}) {
    const url = `${API_URL}/${resource}`;
    let file;
    let defaults = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        }
    };

    config = { ...defaults, ...config };
    return file = await fetch(`${API_URL}/${resource}`, config)
        .catch(e => {
            throw new Error(getStore(format)("notifications.network_error"));
        })
        .then(response => {
            if (!response.ok) {
                if (response.status === 502) {
                    throw new Error(getStore(format)("notifications.network_error"))
                }
                else {
                    throw new Error(getStore(format)("notifications.network_error"));
                }
            }
            return response;
        })
        ;
}

export function saveDocument(resource, data = {}, files = [], config = {}) {
    const url = `${API_URL}/${resource}` + (data.id ? `/${data.id}` : '');
    const method = 'POST';

    // file uploads
    let formData = new FormData();

    formData.append('data', JSON.stringify(data));

    files.map((value, key) => {
        formData.append('file_obj', value);
    });

    let defaults = {
        method: method,
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
        body: formData,
    };

    config = { ...defaults, ...config };

    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export function open(url) {
    window.open(`${API_URL}/${url}`);
}

/**
 * Parse API 422 errors
 * Return flatten object: {field}=[error1, error2]
 * @param {} data
 * @return {}
 */
export function flatten422Errors(data) {
    if (!data.detail) return {};

    let errors = {};

    data.detail.map(obj => {
        let field = obj.loc[1];
        errors[field] = errors[field] || [];
        errors[field].push(obj.type);
    });

    return errors;
}

export function translate403Errors(data) {
    setLocale();
    let error = ""
    if (data == 'deleted_user') error = getStore(format)("errors.deleted_user");
    if (data == 'invalid_token') error = getStore(format)("errors.invalid_token");
    if (data == 'expired_token') error = getStore(format)("errors.expired_token");
    if (data == 'already_used_token') error = getStore(format)("errors.already_used_token");
    return error;

}


export function signUp(resource, data = {}, config = {}) {

    const url = `${API_URL}/${resource}/`;
    const method = 'POST';

    let defaults = {
        method: method,
        headers: {
            'Content-Type': "application/json",
        },
        body: JSON.stringify(data),
    };

    config = { ...defaults, ...config };

    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export function validateEmail(resource, token, config = {}) {
    const url = `${API_URL}/${resource}/`;
    const method = 'POST';

    let data = { token: token }

    let defaults = {
        method: method,
        headers: {
            'Content-Type': "application/json",

        },
        body: JSON.stringify(data),
    };

    config = { ...defaults, ...config };

    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export function patchOwnUSer(data = {},) {
    let defaults = {
        method: "PATCH",
        headers: {
            Authorization: `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    };

    let config = { ...defaults };
    return fetch(`${API_URL}/user`, config)
        .then(response => {
            return response;
        })
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        ;
}

export function translateErrorMessages(errorString, asset) {
    setLocale();
    if (errorString == 'The workspace has reached the allowed limit') {
        return getStore(format)("errors.limit_reached") + asset + ".";
    }
    if ((asset == 'IPs_massive' || asset == 'domains_massive' || asset == 'hostnames_massive' || asset == 'networks_massive') && errorString == 'The object already exists') {
        return getStore(format)("errors.objects_exist");
    }
    if (errorString == 'The object already exists') {
        return getStore(format)("errors.object_exists");
    }
    if (errorString == 'too_short' || errorString == 'leaked') {
        return getStore(format)("errors.too_short");
    }
    if (errorString == 'value is not a valid email address') {
        return getStore(format)("errors.invalid_email");
    }
    if (errorString.includes("Domain not found")) {
        return getStore(format)("errors.domain_not_found");
    }
    if (errorString == 'The requested asset can not be created.') {
        return getStore(format)("errors.asset_not_created");
    }
    if (errorString.includes("The workspace has reached the allowed limit") && errorString.includes("target user")) {
        let limit = errorString.split("limit")[1];
        limit = limit.split("for target user")[0];
        return getStore(format)("errors.user_limit", { values: { limit: limit } });
    }
}


export function saveSLA(data = {}, config = {}) {
    let defaults = {
        method: "PATCH",
        headers: {
            Authorization: `Bearer ${access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    };

    config = { ...defaults, ...config };
    return fetch(`${API_URL}/v2/sla-config`, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
        .then(response => {
            return response;
        })
        ;
}

export default {
    url: API_URL,
    get,
    search,
    find,
    save,
    saveMultipart,
    updateMultipart,
    upsert,
    taskExecute,
    del,
    patchOwnUSer,
    deleteTags,
    deleteOneResource,
    getFile,
    saveFile,
    saveDocument,
    open,
    flatten422Errors,
    translate403Errors,
    signUp,
    validateEmail,
    translateErrorMessages,
    saveSLA
}